import { LinearGradient } from 'expo-linear-gradient';
import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';

import { styles } from './styles';

const GradientButton = ({ ...props }) => {
  return (
    <TouchableOpacity {...props}>
      <LinearGradient
        start={{ x: -1, y: 0 }}
        end={{ x: 1, y: 0 }}
        colors={["#16195B", "#1FBFB5"]}
        style={styles.button}
      >
        <Text style={styles.text}>{props.children}</Text>
      </LinearGradient>
    </TouchableOpacity >
  );
}

export default GradientButton;